import styled from 'styled-components';

const DebugOptions = styled.div`
  position: relative;
  display: flex;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, .2);
  top: ${({ hidden }) => (hidden ? '100vh' : '0')};
  width: ${({ hidden }) => (hidden ? '0' : 'auto')};
  height: ${({ hidden }) => (hidden ? '0' : 'auto')};
  flex-wrap: wrap;
  align-items: center;
  transition: top 0.15s;
`;
export default DebugOptions;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugOptions.jsx